export const GET_HOME_PENDING = "GET_HOME_PENDING"
export const GET_HOME_SUCCESS = "GET_HOME_SUCCESS"
export const GET_HOME_FAILURE = "GET_HOME_FAILURE"
